/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'clock': {
    viewBox: '0 0 32 32',
    data: '<g><path d="M16,1C7.7,1,1,7.7,1,16c0,8.3,6.7,15,15,15c8.3,0,15-6.7,15-15C31,7.7,24.3,1,16,1z M16,29C8.8,29,3,23.2,3,16S8.8,3,16,3 s13,5.8,13,13S23.2,29,16,29z"/><path d="M16,6c-0.6,0-1,0.4-1,1v8.6L9.6,21c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.4,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3l5.7-5.6 c0.1-0.1,0.2-0.2,0.2-0.3C17,16.3,17,16.1,17,16V7C17,6.4,16.6,6,16,6z"/></g>'
  }
})
